import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles/base.css";
import "./styles/animations.css";
import "./styles/components.css";

export function initChatbot() {
  const frontendBaseUrl = import.meta.env.VITE_FRONTEND_BASE_URL;
  let rootElement = document.getElementById("chatbot-root");
  if (!rootElement) {
    const div = document.createElement("div");
    div.id = "chatbot-root";
    document.body.appendChild(div);
    rootElement = div;
  }

  // Shadow DOMを使う
  const shadowRoot = rootElement.attachShadow({ mode: "open" });
  const linkElement = document.createElement("link");
  linkElement.rel = "stylesheet";
  linkElement.href = `${frontendBaseUrl}/index.css`;

  linkElement.onload = () => {
    createRoot(shadowRoot).render(<App />);
  };

  linkElement.onerror = () => {
    createRoot(shadowRoot).render(<App />);
  };

  shadowRoot.appendChild(linkElement);
}

if (typeof window !== "undefined" && !import.meta.env.DEV) {
  window.addEventListener("load", () => {
    initChatbot();
  });
}
